module.exports = __webpack_public_path__ + "img/google-icon.69f3d1b.svg";